import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DynamicTranslationDirective } from './dynamic-translation.directive';
import { TranslatePipe } from './translate.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [DynamicTranslationDirective, TranslatePipe],
  exports: [DynamicTranslationDirective, TranslatePipe]
})
export class DynamicTranslationModule {}
